module.exports = __webpack_public_path__ + "img/609.bb696647.png";